module.exports = __webpack_public_path__ + "img/c.864fe58b.jpg";